<!-- eslint-disable vue/no-mutating-props -->
<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="relative z-50">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
      </TransitionChild>
      <div class="fixed inset-0 z-10 w-screen overflow-y-auto px-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center lg:items-center lg:p-0"
          @click="closeModal()">
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 lg:translate-y-0 lg:scale-95"
            enter-to="opacity-100 translate-y-0 lg:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 lg:scale-100"
            leave-to="opacity-0 translate-y-4 lg:translate-y-0 lg:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-background px-4 pb-4 pt-5 text-left shadow-xl transition-all lg:my-8 lg:w-full lg:max-w-lg lg:p-6">
              <div class="absolute right-0 top-0 pr-4 pt-4">
                <button
                  type="button"
                  class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  @click="closeModal">
                  <span class="sr-only">{{ $t("Close") }}</span>
                  <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div v-if="open" class="text-center">
                <DialogTitle as="h3" class="text-xl font-semibold leading-4 text-gray-900">{{
                  $t("Password expired")
                }}</DialogTitle>
                <DialogDescription class="mt-2">{{
                  $t("For security reasons you need to change your password.")
                }}</DialogDescription>
              </div>
              <hr class="my-6" />
              <div>
                <PasswordChange @hide="closeModal()" />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot, DialogDescription } from "@headlessui/vue";
import PasswordChange from "./PasswordChange.vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";

const { open } = defineProps({
  open: { required: false },
});

const emit = defineEmits(["hideModal"]);
const closeModal = () => {
  emit("hideModal");
};
</script>
